const config = {
    apiUrl: "http://FG-ALB-API-APP-781943029.us-east-1.elb.amazonaws.com",
    uiUrl : "http://107.22.216.186",
    featureFlag: true
  };

  export default config;